<div
  class="tds-u-w-100 tds-u-h-100 tds-u-flex tds-u-flex-dir-col tds-u-align-center tds-u-justify-center background-totem"
>
  <div class="tds-text-center tds-u-mb4">
    <h1 class="tds-headline-01 tds-u-mb2">Bem-vindo ao Control Center</h1>
    <p class="tds-body-01 tds-u-mb3">
      Por favor, escolha como deseja retirar sua senha de atendimento:
    </p>
  </div>

  <div class="tds-u-flex tds-u-gap4 action-cards-container">
    <button
      class="kiosk-card primary-card tds-u-flex tds-u-flex-dir-col tds-u-align-center tds-u-justify-center"
      (click)="goToBiometry()"
    >
      <tds-icon name="camera" size="96px" class="tds-u-mb3"></tds-icon>
      <h2 class="tds-headline-02 tds-u-m0">Sou Cadastrado</h2>
      <p class="tds-body-01 tds-u-mt1">Reconhecimento Facial</p>
    </button>

    <button
      class="kiosk-card secondary-card tds-u-flex tds-u-flex-dir-col tds-u-align-center tds-u-justify-center"
      (click)="generatePass()"
    >
      <tds-icon name="print" size="96px" class="tds-u-mb3"></tds-icon>
      <h2 class="tds-headline-02 tds-u-m0">Não Cadastrado</h2>
      <p class="tds-body-01 tds-u-mt1">Gerar Senha Manual</p>
    </button>
  </div>

  <div class="tds-u-mt3 tds-text-center">
    <p class="tds-detail-01 tds-text-grey-900">
      Em caso de dúvidas, dirija-se ao guichê de atendimento.
    </p>
  </div>
</div>
